<template>
  <!-- Fixed Back Header (white, subtle border/shadow to match new UI) -->
  <header class="fixed top-0 left-0 right-0 z-[1001] bg-white border-b border-gray-200 shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center">
      <!-- Back button -->
      <button
        @click="goBack"
        class="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-white border border-gray-200
               hover:bg-gray-50 text-gray-700 hover:text-gray-900 shadow-sm
               focus:outline-none focus:ring-2 focus:ring-primary"
        aria-label="Back"
      >
        <span class="material-symbols-outlined text-xl">arrow_back</span>
      </button>

      <!-- Title / slot -->
      <h1 class="ml-3 sm:ml-4 text-gray-900 text-lg sm:text-xl font-bold tracking-tight truncate">
        <slot>Back</slot>
      </h1>
    </div>
  </header>

  <!-- spacer to offset fixed header height -->
  <div class="header-space h-14 sm:h-16"></div>
</template>

<script>
export default {
  name: 'AppHeaderBack',
  methods: {
    goBack() {
      // If on login or register page, always go to generator page (now '/')
      const authRoutes = ['/login', '/register', '/forgot-password'];
      if (authRoutes.includes(this.$route.path)) {
        this.$router.push('/');
        return;
      }
      const referrer = document.referrer;
      const isSameOrigin = referrer && referrer.startsWith(window.location.origin);
      if (window.history.length > 1 && isSameOrigin) {
        window.history.back();
      } else {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
/* Keep only layout heights for spacer + header */
header {
  height: 56px;
}
.header-space {
  height: 56px;
}
@media (min-width: 640px) {
  header,
  .header-space {
    height: 64px;
  }
}
</style>